import React from 'react';
import PropTypes from 'prop-types';
import { isArray } from 'underscore';
import { Card, CardBody, CardHeader, Button, Row, Col } from 'reactstrap';
import Icon from '../../common/containers/icon';
import SearchInput from '../../common/search/searchInput';
import StatusFilter from './statusFilter';
import JobsFilter from './jobsFilter';
import entityComposition from '../../common/classes/entityComposition';
class EmployeesFilters extends React.Component {
  constructor(props) {
    super(props);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleFilterClear = this.handleFilterClear.bind(this);
    this.handleSearch = text => this.handleFilter('text', text);
    this.handleSearchClear = () => this.handleFilter('text', '');
    this.handleFilter('status', '1');
  }
  handleFilter(prop, value) {
    const {
      employee,
      employeeActions
    } = this.props;
    const newFilters = JSON.parse(JSON.stringify(employee.indexQuery.filters));
    if (value !== null) {
      newFilters[prop] = value;
    } else {
      delete newFilters[prop];
    }
    employeeActions.serverFilter(newFilters, employee.indexQuery);
  }
  handleFilterClear() {
    const {
      employeeActions,
      employee
    } = this.props;
    employeeActions.serverFilter(employee.initialIndexQuery.filters, employee.initialIndexQuery);
  }
  render() {
    const {
      employee: {
        indexQuery: {
          filters: {
            job = [],
            text = '',
            status = ''
          }
        }
      }
    } = this.props;
    let jobs = [];
    if (job) {
      jobs = isArray(job) ? job : [job];
    }
    return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 8
    }, /*#__PURE__*/React.createElement("h3", null, "Filter")), /*#__PURE__*/React.createElement(Col, {
      xs: 4
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: this.handleFilterClear,
      className: "float-md-right t-ec-filter-clear"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "times-circle",
      weight: "far"
    }), " Clear")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(SearchInput, {
      type: "text",
      text: text,
      onChange: this.handleSearch,
      onClear: this.handleSearchClear
    }), /*#__PURE__*/React.createElement(StatusFilter, {
      status: status,
      onFilter: this.handleFilter
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: '10px'
      }
    }, /*#__PURE__*/React.createElement(JobsFilter, {
      jobs: jobs,
      onFilter: this.handleFilter
    }))));
  }
}
EmployeesFilters.propTypes = {
  employee: PropTypes.shape({
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({
        job: PropTypes.arrayOf(PropTypes.shape({})),
        status: PropTypes.string,
        text: PropTypes.string
      }).isRequired
    }),
    initialIndexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    })
  }).isRequired,
  employeeActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired
};
export { EmployeesFilters as TestEmployeesFilters };
export default entityComposition(EmployeesFilters, ['employee']);